import React from 'react';
import styled from '@emotion/styled';
import Spinner from '@atlaskit/spinner';
import CheckCircleOutlineIcon from '@atlaskit/icon/glyph/check-circle-outline';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { ValidationStateType } from '../../types';

type IconValidationType = {
  readonly validationState?: ValidationStateType;
};

export const IconValidation = React.memo(
  ({ validationState }: IconValidationType) => {
    function RenderIcon() {
      switch (validationState) {
        case 'validating':
          return (
            <SpinnerWrapper>
              <Spinner size="small" />
            </SpinnerWrapper>
          );
        case 'error':
          return <WarningIcon label="error" primaryColor="#DE350B" />;
        case 'success':
          return (
            <CheckCircleOutlineIcon label="success" primaryColor="#36B37E" />
          );
        default:
          return null;
      }
    }

    return (
      <IconValidationWrapper>
        <RenderIcon />
      </IconValidationWrapper>
    );
  }
);

const IconValidationWrapper = styled.div`
  padding-right: 8px;
  display: flex;
  font-size: 16px;
  -webkit-box-align: center;
  align-items: center;

  svg {
    margin-bottom: 0px;
  }
`;

const spinnerWidth = '20px';
const SpinnerWrapper = styled.div`
  position: relative;
  display: block;

  div {
    width: ${spinnerWidth};
    height: ${spinnerWidth};
  }
  span {
    display: inline-block;
    padding: 0;
    margin: 0;
    min-width: ${spinnerWidth};
    width: ${spinnerWidth};
    height: ${spinnerWidth};
    transform-origin: 50% 50%;
  }
  svg {
    padding: 0;
    margin: 0;
    width: ${spinnerWidth};
    height: ${spinnerWidth};
  }
`;
